import { render, staticRenderFns } from "./weteacheManage.vue?vue&type=template&id=0c02d85a&scoped=true"
import script from "./weteacheManage.vue?vue&type=script&lang=js"
export * from "./weteacheManage.vue?vue&type=script&lang=js"
import style0 from "./weteacheManage.vue?vue&type=style&index=0&id=0c02d85a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c02d85a",
  null
  
)

export default component.exports